import { BusinessSociabilitySaysApproved, MapperNotes } from "common/types";
import { Info } from "phosphor-react";
import React from "react";
import { useI18N } from "common/hooks";

interface MapperNotesProps {
  data: MapperNotes[];
  publicNotes: BusinessSociabilitySaysApproved[];
  gotoMapperView: () => void;
}

const MapperNotesComponent = ({
  data,
  publicNotes,
  gotoMapperView,
}: MapperNotesProps) => {
  const i18n = useI18N();

  // Function to truncate text to a maximum character length
  const truncateText = (text: string, maxLength: number = 50) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  // Prepare all notes for combined display
  const allNotes = [];
  
  // Add mapper notes first
  data.forEach((note, index) => {
    const actionTitle = note.action_title;
    const noteText = note.notes ?? note.action_title;
    const truncatedNoteText = truncateText(noteText ?? "");
    allNotes.push(
      <React.Fragment key={`mapper-${index}`}>
        <span className="underline">{actionTitle}</span> - {truncatedNoteText}
      </React.Fragment>
    );
  });
  
  // Add public notes
  publicNotes.forEach((note, index) => {
    const title = note.business_note_title;
    const text = note.business_note_text;
    const truncatedText = truncateText(text ?? "");
    allNotes.push(
      <React.Fragment key={`public-${index}`}>
        {title} - {truncatedText}
      </React.Fragment>
    );
  });

  return (
    <section className="mb-4">
      <div className="w-full bg-primary-50 dark:bg-[#313A71] border border-primary-200 rounded-xl p-3">
        <div className="flex">
          {/* Icon column */}
          <div className="flex-shrink-0 mr-3">
            <Info
              size={28}
              className="!text-primary-500 dark:!text-primary-300"
            />
          </div>

          <div className="flex-1">
            {/* Notice count */}
            <div className="mb-1">
              <span className="paragraph-small-semibold text-primary-800 dark:text-primary-50">
                {publicNotes.length > 0
                  ? `${data.length} Mapper Note(s) • ${publicNotes.length} Public note(s)`
                  : `${data.length} Mapper Note(s)`}
              </span>
            </div>
            <div className="flex-1">
              <p className="line-clamp-2 paragraph-small-medium text-primary-800 dark:text-primary-50">
                {allNotes.map((note, index) => (
                  <React.Fragment key={index}>
                    {index > 0 && <span>, </span>}
                    {note}
                  </React.Fragment>
                ))}
              </p>
              <p
                className="paragraph-small-medium text-primary-500 dark:text-primary-300 mt-1 cursor-pointer"
                onClick={gotoMapperView}
              >
                {i18n.get("viewNoteDetails")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapperNotesComponent;
